export const PaymentSuccessDialogType = {
  CREDITS: 'credits',
  SUBSCRIPTION: 'subscription',
};
